<template>
  <div
    class="f-column w-100"
    style="gap: var(--solfigr-gap)"
    :class="{ gw_loading: shortcutsLoading || presetLoading }"
  >
    <ExpandCard
      :canClose="false"
      style="
        --clr-back-title: var(--clr-black-2);
        --clr-back-title-hover: var(--clr-black-2);
        --clr-back-title-active: var(--clr-black-2);
        --title-color: var(--clr-white-0);
        --content-padding: var(--solfigr-padding);
        --radius: 4px;
        --title-padding: 0 0.25rem 0 0.75rem;
      "
      :style="{
        '--max-height': !isPreflop && tournamentType === 'icm' ? 'var(--vh-3)' : 'var(--vh-7-5)',
      }"
    >
      <template #title>
        <div class="d-flex flex-1">
          <div class="my-auto mr-2">
            {{ $t('solfigr.solution') }}
          </div>

          <LinkGuide
            v-if="!$i18n.g1"
            class="weight_500 ml-auto pa-1"
            :link="
              isPreflop
                ? links_url_links.preflop_ai.url
                : links_url_links.how_to_build_custom_solutions.url
            "
            :text="
              $t(`guides.how_to_build_xxx_custom_solutions`, {
                str: (isPreflop ? $t(`common.preflop`) : $t(`common.flop`)).toLowerCase(),
              })
            "
            @click.stop
          />
        </div>
      </template>

      <div
        class="f-column"
        style="gap: var(--solfigr-gap)"
      >
        <div
          class="f-column"
          :class="{ gw_loading: shortcutsLoading || presetLoading }"
        >
          <GwTitleTooltip
            class="solfigrstpot_item_title"
            :title="$t('solfigr.streets.title')"
            :tooltip="$t('solfigr.streets.title_tooltip')"
            style="margin: 0 0 0.25rem 0"
          />
          <div
            class="f-center"
            style="gap: 0.25rem"
          >
            <GwBtns
              :options="['preflop', 'flop']"
              class="gwbtns_horizontal_grey solfigrtp_top_btns gw_loading_text"
              :value="startStreet"
              style="
                margin-right: 0.5rem;
                border-radius: 4px;
                background: var(--clr-black-1-3);
                --gwbtn-clr-back: var(--clr-black-1-3);
                --gwbtn-clr-active-white: var(--clr-black-3);
                --gwbtn-size: 1rem;
                --gwbtn-height: 1.875rem;
                --gwbtns-padding: 2px;
              "
              tstPrefix="solfigr_street"
              @click="
                (_e, item) => {
                  $emit('update:startstreet', item)
                }
              "
            >
              <template #default="{ item }">
                {{ $t(`common.${item}`) }}
              </template>
            </GwBtns>

            <div
              v-if="startStreet === 'flop'"
              data-tst="solfigr_prefill_button"
              class="gw_btn-v1 gw_btn_text gw_btn_outline weight_500"
              style="--height: 1.875rem; font-size: 0.8rem"
              @click="openSolfigrShortcutsDialog()"
            >
              <i class="text-normal mdi mdi-auto-fix mr-2"></i>
              {{ $t(`solfigr.prefill_ranges`) }}
            </div>
            <div class="mr-auto role_spacer"></div>
          </div>
        </div>

        <div
          v-if="!isPreflop"
          class="f-column"
        >
          <GwTitleTooltip
            class="solfigrstpot_item_title"
            :title="$t(`solfigr.icm.model_type`)"
            :tooltip="
              $t(`solfigr.icm.model_type_tooltip`, {
                linkText: $i18n.g1
                  ? $t(`solfigr.icm.independent_chip_model`)
                  : $t('common.link_text', {
                      url: links_url_links.icm_pressure_guide.url,
                      cssClass: 'weight_500 text-underline_hover',
                      text: $t(`solfigr.icm.model_type_tooltip_link_text`),
                    }),
              })
            "
            style="margin: 0 0 0.25rem 0"
          />
          <GwBtns
            :options="['chipev', 'icm']"
            class="gwbtns_horizontal_grey solfigrtp_top_btns gw_loading_text mr-auto"
            style="
              margin-right: 0.5rem;
              border-radius: 4px;
              background: var(--clr-black-1-3);
              --gwbtn-clr-back: var(--clr-black-1-3);
              --gwbtn-clr-active-white: var(--clr-black-3);
              --gwbtn-size: 1rem;
              --gwbtn-height: 1.875rem;
              --gwbtns-padding: 2px;
            "
            :value="tournamentType"
            @click="
              (_e, item) => {
                $emit(`update:input`, { type: 'tournamentType', num: item })
              }
            "
          >
            <template #default="{ item }">
              {{ $t(`solfigr.icm.${item}`) }}
            </template>
          </GwBtns>
        </div>

        <div
          v-if="isPreflop || tournamentType === 'chipev'"
          class="d-flex f-column f-wrap"
          style="gap: var(--solfigr-gap)"
        >
          <SolfigrStreetInputs
            class="solfigrtp_item mr-auto"
            :loading="shortcutsLoading || presetLoading"
            :namespace
            :isPreflop
            :pot
            :inputTabIndex
            :stack
            :blind
            :ante
            :anteDistributionMethod
            :allowLimp
            :allowRake
            :rakePercent
            :rakeCap
            :preflopRakeType
            :players
            @update:input="
              ({ num, type }) => {
                $emit('update:input', { num, type })
              }
            "
          />

          <SolfigrPlayers
            v-if="startStreet === 'flop'"
            class="solfigrtp_item"
            style="--player-table-size: 5.2rem"
            :loading="shortcutsLoading || presetLoading"
            :players
            :shouldShowAddPlayerButton
            @click="playerPosition => openSolfigrRangesDialog(playerPosition)"
            @click:add="addPlayer"
            @click:remove="removePlayer"
          />
          <SolfigrStacks
            v-if="
              startStreet === 'flop' &&
              players.length > 2 &&
              $store.getters.user_has_flag('SOL_3WAY')
            "
            :conf
            :hand-details="stacks"
            :has-bounty-instant="false"
            :has-bounty-total="false"
            :players
            @update:stack="
              ({ key, value }) => {
                $emit('update:input', { type: key.split('_').join('_flop_'), num: value })
              }
            "
          />
        </div>

        <div
          v-else-if="tournamentType === 'icm'"
          class="f-column"
          style="gap: 1rem"
        >
          <SolfigrIcmTournamentStructureExpand
            :namespace
            :icmTournament
            :hasPayouts
            :loading="shortcutsLoading || presetLoading"
            @update:icmTournament="value => $emit('update:icmTournament', value)"
          />

          <SolfigrIcmHandDetails
            :namespace
            :loading="shortcutsLoading || presetLoading"
            :players
            :icmHandDetails
            :hasBountyInstant
            :hasBountyTotal
            :bountyInstantPercentage="icmTournament.bounty_instant_percentage"
            @click="playerPosition => openSolfigrRangesDialog(playerPosition)"
            @update:icmHandDetails="value => $emit('update:icmHandDetails', value)"
          />

          <SolfigrIcmOtherStacksExpand
            :namespace
            :loading="shortcutsLoading || presetLoading"
            :icmPlayersAndStacks
            :hasBountyAvg
            :icmHandDetails
            :players
            @update:icmPlayersAndStacks="value => $emit('update:icmPlayersAndStacks', value)"
          />
        </div>
      </div>
    </ExpandCard>
  </div>
</template>

<script>
import LinkGuide from '@/components/AppBar/LinkGuide'
import GwBtns from '@/components/lib/GwBtns'
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'
import SolfigrPlayers from '@/components/ConfigureSolution/SolfigrPlayers'
import SolfigrStreetInputs from '@/components/ConfigureSolution/SolfigrStreetInputs'
import SolfigrIcmTournamentStructureExpand from '@/components/ConfigureSolution/SolfigrIcmTournamentStructureExpand'
import SolfigrIcmOtherStacksExpand from '@/components/ConfigureSolution/SolfigrIcmOtherStacksExpand'
import SolfigrIcmHandDetails from '@/components/ConfigureSolution/SolfigrIcmHandDetails'
import SolfigrStacks from '@/components/ConfigureSolution/SolfigrStacks'
import float_mix from '@/mixins/float_mix'
import links_mix from '@/mixins/links_mix'
import { SNK } from '@/helpers/helpers'

export default {
  name: 'SolfigrSolution',
  components: {
    SolfigrStreetInputs,
    SolfigrPlayers,
    SolfigrIcmTournamentStructureExpand,
    SolfigrIcmOtherStacksExpand,
    SolfigrIcmHandDetails,
    SolfigrStacks,

    LinkGuide,
    GwBtns,
    GwTitleTooltip,
    ExpandCard,
  },
  mixins: [float_mix, links_mix],
  props: {
    namespace: { String, required: true },
    startStreet: String,
    gameformat: Object,
    shortcut: Object,
    stack: Number,
    pot: Number,
    blind: Number,
    ante: Number,
    rakePercent: Number,
    rakeCap: Number,
    preflopRakeType: String,
    anteDistributionMethod: String,
    allowLimp: Boolean,
    allowRake: Boolean,
    inputTabIndex: Number,
    tournamentType: String,
    shortcutsLoading: { type: Boolean, default: true },
    presetLoading: { type: Boolean, default: true },
    icmTournament: Object,
    icmPlayersAndStacks: Object,
    icmHandDetails: Object,
    players: Array,
    stacks: Object,
    shouldShowAddPlayerButton: Boolean,
  },
  emits: [
    'update:startstreet',
    `update:input`,
    'update:icmPlayersAndStacks',
    'update:icmHandDetails',
    'update:icmTournament',
  ],
  data() {
    this.conf = getSolfigrFields()
    return {}
  },
  methods: {
    addPlayer() {
      this.$store.dispatch(SNK('slfrm_addPlayer', this.namespace))
    },
    removePlayer() {
      this.$store.dispatch(SNK('slfrm_removePlayer', this.namespace))
    },
    openSolfigrShortcutsDialog() {
      const tmpNamespace = 'tmp/extra2'

      let prefill_query_gameformat = localStorage.getItem('prefill_query_gameformat')
      try {
        prefill_query_gameformat = JSON.parse(prefill_query_gameformat)
        this.$store.dispatch(`${this.namespace}/router_update_query`, {
          query: prefill_query_gameformat,
          push: false,
          replace: false,
          saveLocally: false,
        })
      } catch (e) {
        prefill_query_gameformat = null
      }

      // is someone messses up localstorage
      // and gmf is not set correctly from prefill_query_gameformat
      // >> set it from StudySolution root
      if (!this.$store.getters[`${this.namespace}/gameformat`]) {
        const { query_gameformat } = this.$store.getters
        this.$store.dispatch(`${this.namespace}/router_update_query`, {
          query: query_gameformat,
          push: false,
          replace: false,
          saveLocally: false,
        })
      }

      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.namespace,
        to_namespace: tmpNamespace,
        queryGroup: 'gmf-selektor',
      })
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.namespace,
        to_namespace: tmpNamespace,
        queryGroup: 'router',
      })

      const dialog = `solfigr-shortcuts-dialog_namespace-${this.namespace}_tmpNamespace-${tmpNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    openSolfigrRangesDialog(playerPosition) {
      const dialog = `solfigr-players-ranges-dialog_namespace-${this.namespace}_player-${playerPosition}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
  },
  computed: {
    hasBountyInstant() {
      const conf = getSolfigrFields()
      return conf.bounty_instant.is_active(this.icmTournament.type)
    },
    hasBountyTotal() {
      const conf = getSolfigrFields()
      return conf.bounty_total.is_active(this.icmTournament.type)
    },
    hasBountyAvg() {
      const conf = getSolfigrFields()
      return conf.avg_bounty.is_active(this.icmTournament.type)
    },
    hasPayouts() {
      const conf = getSolfigrFields()
      return conf.payout_levels.is_active(this.icmTournament.type)
    },
    isPreflop() {
      return this.startStreet === 'preflop'
    },
  },
}
</script>
<style lang="scss" scoped>
.solfigrtp {
  min-height: 0;
  min-width: 0;
  flex: 1;
  display: flex;
  justify-content: center;
  overflow: auto;
  gap: var(--solfigr-gap); // flex-direction: column;
  &_box {
    min-height: 0;
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    overflow: hidden;
    &_title {
      border-radius: 4px 4px 0 0;
      display: flex;
      background: var(--clr-black-2);
      padding: 0.5rem 0.75rem;
      &_text {
        font-weight: 500;
      }
    }
    &_content {
      gap: 1.5rem;
      flex: 1;
      min-height: 0;
      min-width: 0;
      display: flex;
      background: var(--clr-black-1);
      gap: 1rem;
    }
  }
}
</style>
